import React from 'react';
import { Logo } from './Logo';
import { SocialLinks } from './SocialLinks';
import './Footer.scss';

export const Footer = ({ siteName }) => (
  <footer className="footer">
    <div className="wrapper footer-body">
      <Logo />
      <div className="sitemap">
        <SocialLinks />
        <span className="legal">© {new Date().getFullYear()} {siteName}</span>
      </div>
    </div>
  </footer>
);
